<template>
  <div class="sm">
    <span v-if="acik" class="sm__doku" aria-hidden="true">
      <i v-for="(n, i) in noktalar" :key="i" :style="{ '--a': n.a, '--d': n.d }"></i>
    </span>
    <logo class="sm__logo" />
    <span v-if="acik" class="sm__yazi">
      <b class="sm__ad"><span>ASL MARKASI</span></b>
      <small class="sm__alt">Markirovka</small>
    </span>
  </div>
</template>

<script lang="ts" setup>
// Menu ust alani (30.09.2026): logo | ince ayrac | "ASL MARKASI" / "MARKIROVKA"
// Arkada soluk mavi DataMatrix noktalari yavasca yanip soner (logoya dogru erir).
// Menu daraltilinca (acik=false) sadece logo kalir.
import logo from '@/components/logo.vue'

defineProps<{ acik: boolean }>()

// 42 sutun x 9 satir (7 px aralik, 256 x 64 alani doldurur). Bir kez uretilir.
const noktalar = Array.from({ length: 42 * 9 }, () => ({
  a: Math.random() < 0.55 ? (0.06 + Math.random() * 0.22).toFixed(2) : '0',
  d: `${(-Math.random() * 7).toFixed(2)}s`,
}))
</script>

<style scoped>
.sm {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 0;
}
.sm__doku {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -16px;
  right: -16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 5px);
  grid-auto-rows: 5px;
  gap: 2px;
  padding: 4px;
  align-content: center;
  overflow: hidden;
  pointer-events: none;
  -webkit-mask-image: linear-gradient(90deg, transparent 30%, #000 70%);
  mask-image: linear-gradient(90deg, transparent 30%, #000 70%);
}
.sm__doku i {
  background: #1d6fe8;
  border-radius: 1px;
  opacity: var(--a);
  animation: smYan 7s ease-in-out infinite;
  animation-delay: var(--d);
}
@keyframes smYan {
  0%, 100% { opacity: var(--a); }
  50% { opacity: calc(var(--a) * 0.25); }
}
.sm__logo {
  position: relative;
  z-index: 1;
  height: 44px;
  flex: none;
}
.sm__yazi {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  line-height: 1.05;
  min-width: 0;
  margin-left: 12px;
  padding-left: 12px;
  border-left: 1px solid #dbe3ee;
}
.sm__ad {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.1em;
  white-space: nowrap;
  color: #0b2a6b;
}
.sm__ad span {
  background: linear-gradient(90deg, #0b2a6b 0%, #0b2a6b 40%, #38bdf8 50%, #0b2a6b 60%, #0b2a6b 100%);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: smHarf 9s ease-in-out infinite;
}
@keyframes smHarf {
  0%, 60% { background-position: 100% 0; }
  100% { background-position: 0 0; }
}
.sm__alt {
  font-size: 9.5px;
  color: #64748b;
  margin-top: 4px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  white-space: nowrap;
}
:global(.dark) .sm__yazi {
  border-left-color: #374151;
}
:global(.dark) .sm__ad span {
  background-image: linear-gradient(90deg, #dbeafe 0%, #dbeafe 40%, #38bdf8 50%, #dbeafe 60%, #dbeafe 100%);
}
:global(.dark) .sm__alt {
  color: #94a3b8;
}
@media (prefers-reduced-motion: reduce) {
  .sm__doku i,
  .sm__ad span {
    animation: none;
  }
}
</style>
